import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

const withRecaptcha = (WrappedComponent) => {
  const RecaptchaHOC = (props) => {
    return (
      <GoogleReCaptchaProvider reCaptchaKey={process.env.REACT_APP_SITE_KEY}>
        <WrappedComponent {...props} />
      </GoogleReCaptchaProvider>
    );
  };

  return RecaptchaHOC;
};

export default withRecaptcha;
